import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { dialogManager } from '../stores/DialogManager';

export const CloseYoutubeButton = () => {
    return (
        <IconButton
            onClick={() => dialogManager.closeYoutube()}
            edge="start"
            color="inherit"
            size="large"
        >
            <CloseIcon />
        </IconButton>
    );
};

CloseYoutubeButton.displayName = 'CloseYoutubeButton';
